import React, { useState, useEffect } from 'react';

export default function Contratos({ usuario, onBackToMenu }) {
  const [contratos, setContratos] = useState([]);
  const [modalAbierto, setModalAbierto] = useState(false);
  const [cargando, setCargando] = useState(false);

  // Estado del formulario de contratos
  const [formData, setFormData] = useState({
    documento_empleado: '',
    nombre_empleado: '',
    tipo_contrato: 'Término Fijo',
    fecha_inicio: '',
    fecha_fin: '',
    estado: 'ACTIVO'
  });
  const [archivo, setArchivo] = useState(null);

  useEffect(() => {
    cargarContratos();
  }, []);

  const cargarContratos = async () => {
    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const response = await fetch(`${API_URL}/api/contratos/listar`);
      if (response.ok) {
        const data = await response.json();
        setContratos(data);
      }
    } catch (error) {
      console.error("Error al cargar contratos:", error);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setArchivo(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCargando(true);

    try {
      const API_URL = process.env.REACT_APP_API_URL;
      const data = new FormData();
      data.append('documento_empleado', formData.documento_empleado);
      data.append('nombre_empleado', formData.nombre_empleado);
      data.append('tipo_contrato', formData.tipo_contrato);
      data.append('fecha_inicio', formData.fecha_inicio);
      data.append('fecha_fin', formData.fecha_fin);
      data.append('estado', formData.estado);
      data.append('creado_por', usuario?.nombres || 'Admin');
      
      if (archivo) {
        data.append('archivo', archivo);
      }

      const response = await fetch(`${API_URL}/api/contratos/crear`, {
        method: 'POST',
        body: data, 
      });

      if (response.ok) {
        setModalAbierto(false);
        setFormData({
          documento_empleado: '',
          nombre_empleado: '',
          tipo_contrato: 'Término Fijo',
          fecha_inicio: '',
          fecha_fin: '',
          estado: 'ACTIVO'
        });
        setArchivo(null);
        cargarContratos(); 
      } else {
        alert('Error al guardar el contrato');
      }
    } catch (error) {
      console.error("Error:", error);
      alert('Error de conexión');
    } finally {
      setCargando(false);
    }
  };

  // Validación ABAC
  const esSuperAdmin = String(usuario?.cargo || "").toUpperCase().includes("SUPER");
  const permisosAvanzados = typeof usuario?.permisos_avanzados === 'string' ? JSON.parse(usuario.permisos_avanzados) : (usuario?.permisos_avanzados || {});
  const permisosMicros = permisosAvanzados.micros || permisosAvanzados;
  const puedeCrear = esSuperAdmin || permisosMicros["Contratos"]; 

  return (
    <div className="w-full min-h-screen p-4 sm:p-8 animate-fade-in relative z-10">
      <div className="bg-white/40 backdrop-blur-[40px] rounded-[34px] shadow-[0_20px_50px_rgba(0,0,0,0.1)] p-6 sm:p-10 max-w-6xl mx-auto border border-white/60">
        
        {/* Cabecera */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center border-b border-gray-400/20 pb-6 mb-8 gap-4">
          <div className="flex items-center gap-4">
            <div className="w-14 h-14 rounded-2xl bg-indigo-100 text-indigo-600 flex items-center justify-center text-2xl shadow-inner border border-indigo-200">
              📄
            </div>
            <div>
              <h2 className="text-2xl font-black text-gray-800 tracking-tight">Gestión de Contratos</h2>
              <p className="text-xs font-bold text-gray-500 mt-1 uppercase tracking-wider">Documentación y Vencimientos</p>
            </div>
          </div>
          <div className="flex gap-3">
            {puedeCrear && (
              <button 
                onClick={() => setModalAbierto(true)}
                className="px-6 py-3 rounded-xl bg-indigo-600 hover:bg-indigo-500 text-white text-xs font-black tracking-widest transition-all shadow-[0_0_20px_rgba(79,70,229,.3)] hover:-translate-y-0.5 cursor-pointer"
              >
                + NUEVO CONTRATO
              </button>
            )}
            <button 
              onClick={onBackToMenu}
              className="px-6 py-3 rounded-xl bg-white/70 hover:bg-white text-gray-800 text-xs font-bold transition-all border border-gray-200 shadow-sm hover:-translate-y-0.5 cursor-pointer"
            >
              Volver
            </button>
          </div>
        </div>

        {/* Tabla de Registros */}
        <div className="overflow-x-auto bg-white/50 backdrop-blur-sm rounded-2xl border border-white shadow-sm">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="bg-slate-800 text-white text-[10px] uppercase tracking-widest">
                <th className="p-4 rounded-tl-2xl">Empleado</th>
                <th className="p-4">Tipo de Contrato</th>
                <th className="p-4">Vigencia</th>
                <th className="p-4">Estado</th>
                <th className="p-4 rounded-tr-2xl text-center">Documento</th>
              </tr>
            </thead>
            <tbody className="text-sm text-gray-700">
              {contratos.length === 0 ? (
                <tr>
                  <td colSpan="5" className="p-8 text-center text-gray-500 font-medium italic">
                    No hay contratos registrados.
                  </td>
                </tr>
              ) : (
                contratos.map((con) => (
                  <tr key={con.id} className="border-b border-gray-200/50 hover:bg-white/80 transition-colors">
                    <td className="p-4">
                      <p className="font-bold text-gray-900">{con.nombre_empleado}</p>
                      <p className="text-[10px] text-gray-500">CC: {con.documento_empleado}</p>
                    </td>
                    <td className="p-4">
                      <span className="bg-indigo-100 text-indigo-800 px-3 py-1 rounded-full text-[10px] font-black tracking-wider border border-indigo-200">
                        {con.tipo_contrato}
                      </span>
                    </td>
                    <td className="p-4 text-xs text-gray-600">
                      {new Date(con.fecha_inicio).toLocaleDateString()} {con.fecha_fin ? `➔ ${new Date(con.fecha_fin).toLocaleDateString()}` : '• Indefinido'}
                    </td>
                    <td className="p-4">
                      <span className={`px-2.5 py-1 rounded-full text-[9px] font-black tracking-wider ${con.estado === 'ACTIVO' ? 'bg-emerald-100 text-emerald-800 border border-emerald-200' : 'bg-red-100 text-red-800 border border-red-200'}`}>
                        {con.estado}
                      </span>
                    </td>
                    <td className="p-4 text-center">
                      {con.archivo_url ? (
                        <a 
                          href={`${process.env.REACT_APP_API_URL}${con.archivo_url}`} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="inline-block p-2 bg-blue-100 text-blue-600 rounded-lg hover:bg-blue-200 transition-colors"
                          title="Ver Contrato PDF"
                        >
                          📄
                        </a>
                      ) : (
                        <span className="text-gray-400 text-xs">Sin archivo</span>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

      </div>

      {/* Modal para Crear Contrato */}
      {modalAbierto && (
        <div className="fixed inset-0 z-[9999] bg-slate-900/60 backdrop-blur-md flex items-center justify-center p-4">
          <div className="bg-white rounded-[32px] shadow-2xl p-8 w-full max-w-2xl border border-gray-100 animate-fade-in">
            <div className="flex justify-between items-center mb-6 border-b border-gray-100 pb-4">
              <h3 className="text-xl font-black text-gray-800">Registrar Contrato Laboral</h3>
              <button onClick={() => setModalAbierto(false)} className="w-8 h-8 bg-gray-100 rounded-full text-gray-600 font-bold hover:bg-red-100 hover:text-red-600 transition cursor-pointer">✕</button>
            </div>

            <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-5">
              
              <div className="md:col-span-2 flex gap-4">
                <div className="flex-1">
                  <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1.5">Documento</label>
                  <input type="text" name="documento_empleado" required value={formData.documento_empleado} onChange={handleInputChange} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:ring-2 focus:ring-indigo-500 outline-none transition" placeholder="Ej: 1002345678" />
                </div>
                <div className="flex-[2]">
                  <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1.5">Nombre Completo</label>
                  <input type="text" name="nombre_empleado" required value={formData.nombre_empleado} onChange={handleInputChange} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:ring-2 focus:ring-indigo-500 outline-none transition" placeholder="Ej: Juan Pérez" />
                </div>
              </div>

              <div>
                <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1.5">Tipo de Contrato</label>
                <select name="tipo_contrato" value={formData.tipo_contrato} onChange={handleInputChange} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:ring-2 focus:ring-indigo-500 outline-none transition">
                  <option value="Término Fijo">Término Fijo</option>
                  <option value="Término Indefinido">Término Indefinido</option>
                  <option value="Aprendizaje SENA">Aprendizaje SENA</option>
                  <option value="Prestación de Servicios">Prestación de Servicios</option>
                </select>
              </div>

              <div>
                <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1.5">Estado</label>
                <select name="estado" value={formData.estado} onChange={handleInputChange} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:ring-2 focus:ring-indigo-500 outline-none transition">
                  <option value="ACTIVO">ACTIVO</option>
                  <option value="FINALIZADO">FINALIZADO</option>
                </select>
              </div>

              <div>
                <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1.5">Fecha de Inicio</label>
                <input type="date" name="fecha_inicio" required value={formData.fecha_inicio} onChange={handleInputChange} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:ring-2 focus:ring-indigo-500 outline-none transition" />
              </div>

              <div>
                <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1.5">Fecha de Fin (Opcional)</label>
                <input type="date" name="fecha_fin" value={formData.fecha_fin} onChange={handleInputChange} className="w-full bg-gray-50 border border-gray-200 rounded-xl px-4 py-2.5 text-sm focus:ring-2 focus:ring-indigo-500 outline-none transition" />
              </div>

              <div className="md:col-span-2">
                <label className="block text-[10px] font-black text-gray-500 uppercase tracking-widest mb-1.5">Contrato Escaneado (PDF)</label>
                <div className="w-full border-2 border-dashed border-gray-300 rounded-xl p-4 text-center hover:bg-gray-50 transition cursor-pointer">
                  <input type="file" accept=".pdf,image/*" onChange={handleFileChange} className="text-sm text-gray-600 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-xs file:font-bold file:bg-indigo-50 file:text-indigo-700 hover:file:bg-indigo-100 cursor-pointer" />
                </div>
              </div>

              <div className="md:col-span-2 mt-4">
                <button type="submit" disabled={cargando} className="w-full py-4 rounded-xl bg-slate-900 hover:bg-slate-800 text-white font-black tracking-widest uppercase text-sm transition disabled:opacity-50 cursor-pointer">
                  {cargando ? 'Guardando...' : 'Guardar Contrato'}
                </button>
              </div>

            </form>
          </div>
        </div>
      )}

    </div>
  );
}